//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import {sendEmail, sendMessage, bind, getUserdata} from '@/controller/login'

export default {
    name: 'login',
    data() {
      return {
        inviterAvatar: null,
        loading: true,
        count: 60,
        accountType: null,
        agentStaffName: '',
        agentStaffAvatar: ''
      }
    },
    mounted () {
      // 这里目前做成浏览器进来不查邀请人
      if (!this.isWx) {
        return
      }
      // 获取邀请人信息
      getUserdata({
        agentStaffId: localStorage.getASIByUrl || this.$route.query.staffId,
        callback: res => {
          this.agentStaffName = res.data.agentStaffName
          this.agentStaffAvatar = res.data.agentStaffAvatar
          localStorage.agentType = res.data.agentType
        },
        errorback: () => {
          this.$vux.toast.show({
            text: '获取用户信息失败',
            type: 'cancel',
            width: '200px'
          })
        }
      })
    },
    methods: {
      limitcontent () {
        // 不能输入中文
        this.$refs.username.value = this.$refs.username.value.replace(/[\u4e00-\u9fa5]/g, '')
      },
      countDown () {
        if (this.count > 0) {
          this.$refs.passwordbtn.disabled = 'disabled'
          this.$refs.passwordbtn.classList.add('click')
          this.$refs.passwordbtn.value = '重新获取验证码(' + this.count + ')'
          this.count--
          setTimeout(this.countDown, 1000)
        } else {
          this.$refs.passwordbtn.removeAttribute('disabled')
          this.$refs.passwordbtn.classList.remove('click')
          this.$refs.passwordbtn.value = '获取验证码'
          this.count = 60
        }
      },
      getcode () {
        // 点击获取验证码的时候，将所有错误提示和原先填写的验证码给清除
        this.$refs.verificate.innerText = ''
        if ((/.+@.+\.[a-zA-Z]{2,4}$/.test(this.$refs.username.value)) || (/^1\d{10}$/.test(this.$refs.username.value))) {
          this.countDown()
          if (this.$refs.username.value.indexOf('@') === -1) {
            sendMessage({
              phone: this.$refs.username.value,
              callback: response => {
                this.loading = false
                if (!response.code) {
                  this.$refs.verificate.style.color = '#757575'
                  this.$refs.verificate.innerText = '短信验证码发送成功'
                } else {
                  this.$refs.verificate.style.color = '#ec2020'
                  this.$refs.verificate.innerText = '短信验证码发送失败,请重新点击获取'
                }
              },
              errorback: () => {
                this.loading = false
                this.$refs.verificate.style.color = '#ec2020'
                this.$refs.verificate.innerText = '短信验证码发送失败,请重新点击获取'
              }
            })
          } else {
            sendEmail({
              email: this.$refs.username.value,
              callback: response => {
                this.loading = false
                if (!response.code) {
                  this.$refs.verificate.style.color = '#757575'
                  this.$refs.verificate.innerText = '邮箱验证码发送成功'
                } else {
                  this.$refs.verificate.style.color = '#ec2020'
                  this.$refs.verificate.innerText = '邮箱验证码发送失败,请重新点击获取'
                }
              },
              errorback: () => {
                this.loading = false
                this.$refs.verificate.style.color = '#ec2020'
                this.$refs.verificate.innerText = '邮箱验证码发送失败,请重新点击获取'
              }
            })
          }
        } else if (this.$refs.username.value === '') {
          this.$refs.verificate.style.color = '#ec2020'
          this.$refs.verificate.innerText = '手机号码或邮箱不能为空'
        } else {
          this.$refs.verificate.style.color = '#ec2020'
          this.$refs.verificate.innerText = '手机号码或邮箱格式错误'
        }
      },
      submit() {
        if (!this.$refs.username.value) {
          this.$refs.verificate.style.color = '#ec2020'
          this.$refs.verificate.innerText = '请输入手机号码/邮箱'
        } else if (!this.$refs.password.value) {
          this.$refs.verificate.style.color = '#ec2020'
          this.$refs.verificate.innerText = '请输入验证码'
        } else if (this.$refs.password.value.length !== 4) {
          this.$refs.verificate.style.color = '#ec2020'
          this.$refs.verificate.innerText = '验证码长度为4位'
        } else {
          if (~this.$refs.username.value.indexOf('@')) {
            this.accountType = 2
          } else {
            this.accountType = 1
          }
          bind({
            code: this.$refs.password.value,
            data: this.$refs.username.value,
            type: this.accountType,
            callback: res => {
              if (~this.$refs.username.value.indexOf('@')) {
                sessionStorage.accountEmail = this.$refs.username.value
              } else {
                sessionStorage.accountPhone = this.$refs.username.value
              }
              if (res.data.token) {
                sessionStorage.setItem('token', res.data.token)
              }
              if (res.data.apiUrl) {
                localStorage.apiUrl = res.data.apiUrl
                let urlArr = res.data.staticUrl.match(/^http[s]{0,1}:\/\/(.*?)(\/.*?)\//)
                let after = urlArr[2] || ''
                location.href = `${window.location.origin}${after}/`
                return
              }
              this.$router.push('/corpList')
            },
            errorback: () => {
              this.$vux.toast.show({
                text: '绑定失败',
                type: 'cancel',
                width: '200px'
              })
            }
          })
        }
      }
    }
  }



// WEBPACK FOOTER //
// ./src/components/login.vue